import React from 'react';
import { observable, action } from 'mobx';
import { ArticleGroupQuery_articleGroup } from 'api';

type Required<T> = {
  value: T;
  error: string;
};

type Optional<T> = {
  value: T;
  error: string;
};

const emptyValue = { error: '', value: '' };

class ArticleGroupForm {
  @observable isSubmitting = false;

  @observable id = '';

  @observable title: Required<string> = {
    value: '',
    error: ''
  };
  @observable url: Required<string> = {
    value: '',
    error: ''
  };
  @observable description: Optional<string> = {
    value: '',
    error: ''
  };

  @action init = (articleGroup: ArticleGroupQuery_articleGroup) => {
    this.id = articleGroup.id ? articleGroup.id.toString() : '';
    this.title.value = articleGroup.title || '';
    this.url.value = articleGroup.url;
    this.description.value = articleGroup.description || '';
  };

  @action reset = () => {
    this.id = '';
    this.isSubmitting = false;
    this.title = emptyValue;
    this.url = emptyValue;
    this.description = emptyValue;
  };

  @action getValuesBeforeCreate = () => {
    this.isSubmitting = true;
    return { url: this.url.value };
  };

  @action getValuesBeforeUpdate = () => {
    this.isSubmitting = true;
    const result = {
      articleGroupInput: {
        id: this.id,
        title: this.title.value,
        description: this.description.value
      }
    };

    return result;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @action handleChange = (event: React.ChangeEvent<HTMLInputElement | any>) => {
    switch (event.target.name) {
      case 'title':
      case 'url':
      case 'description':
        this[event.target.name as 'title' | 'url' | 'description'] = {
          error: '',
          value: event.target.value
        };
        break;

      default:
        throw new Error('This field is not supported');
    }
  };

  @action setError = (element: string, error: string) => {
    switch (element) {
      case 'url':
      case 'title':
      case 'description':
        this[element].error = error;
        break;
      default:
        throw new Error('This field is not supported');
    }
  };

  @action validateFields = () => {
    let errors = 0;

    if (!this.url.value) {
      this.url.error = 'URL is required';
      errors += 1;
    }

    return errors;
  };

  @action isValid = () => {
    return this.url.value !== '' && this.url.error === '' && this.title.error === '' && this.description.error === '';
  };
}

export default ArticleGroupForm;
